import type { NumberField, SelectField, RadioField, CheckboxField, TextField, DateField, EmailField, Field } from '.';
import { FieldTypes } from './fieldTypes';

export function isNumberField(field: Field): field is NumberField {
  return field.type === FieldTypes.number;
}

export function isSelectField(field: Field): field is SelectField {
  return field.type === FieldTypes.select;
}

export function isRadioField(field: Field): field is RadioField {
  return field.type === FieldTypes.radio;
}

export function isCheckboxField(field: Field): field is CheckboxField {
  return field.type === FieldTypes.checkbox;
}

export function isTextField(field: Field): field is TextField {
  return field.type === FieldTypes.text;
}

export function isDateField(field: Field): field is DateField {
  return field.type === FieldTypes.date;
}

export function isEmailField(field: Field): field is EmailField {
  return field.type === FieldTypes.email;
}
